//
// Copyright (c) 2023 Emplifi, Inc.
//

import { Plugin } from "ckeditor5";
import ResizeFigureUI from "./resizeFigure/resizeFigureUI";
import ResizeFigureEditing from "./resizeFigure/resizeFigureEditing";

export default class ResizeFigure extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  public static get requires() {
    return [ResizeFigureEditing, ResizeFigureUI];
  }

  // noinspection JSUnusedGlobalSymbols
  public static get pluginName() {
    return "ResizeFigure";
  }
}
